import React, { useEffect } from 'react';
import { useWindowSize } from 'react-use';
import GlobalResults from './components/GlobalResults';
import CountryResults from './components/CountryResults';
import styles from './styles/GCIClient.module.scss';
import RenderedState from './components/RenderedState';
import useGlobalState from './hooks/useGlobalState';
import licenseTXT from './assets/licenses.txt';

const fetchJson = (url) => fetch(url).then((res) => res.json());
const isDevelopment = process.env.REACT_APP_FETCHING_BASE_URL.includes('localhost:3000') || process.env.REACT_APP_FETCHING_BASE_URL.includes('gcr.rheindigital.org');
const path = isDevelopment ? '/data' : '/content/dam/dhl/global/microsites/dhl-nyu/gcr-data';

function GCIClient() {
  const {
    state: { route, dataLoaded },
    setState,
  } = useGlobalState();

  const { width } = useWindowSize();

  useEffect(() => {
    (async () => {
      try {
        const urls = [
          `${process.env.REACT_APP_FETCHING_BASE_URL}${path}/report/flowtrends.csv`,
          `${process.env.REACT_APP_FETCHING_BASE_URL}${path}/report/trends.csv`,
          `${process.env.REACT_APP_FETCHING_BASE_URL}${path}/report/country.csv`,
        ];
        const [flowtrendsReport, trendsReport, countryResultsReport] = await Promise.all(
          urls.map(fetchJson),
        );
        setState({
          individualFlowtrends: flowtrendsReport,
          trends: trendsReport,
          countryResults: countryResultsReport,
          dataLoaded: true,
        });
      } catch (err) {
        setState({
          dataLoadingError: true,
        });
      }
    })();
  }, [setState]);

  useEffect(() => {
    if (width < 700) {
      setState({
        hasDesktopFeatures: false,
      });
    } else {
      setState({
        hasDesktopFeatures: true,
      });
    }
  }, [width, setState]);

  return (
    <div className={styles.wrapper}>
      {dataLoaded ? (
        <>
          {route === 'global' && <GlobalResults />}
          {route === 'country' && <CountryResults />}
        </>
      ) : (
        <RenderedState />
      )}
      <a
        href={licenseTXT}
        className={styles.licenseTXT}
        target="_blank"
        rel="noopener noreferrer"
      >
        License info
      </a>
    </div>
  );
}

export default GCIClient;
